/**
 * Slovenia 2026 travel plan — transcribed from docs/slovenia-2026.pdf
 * Single source of truth for supabase/seed.sql (AG-05)
 */

const MAPS = {
  jasna: 'https://www.google.com/maps/search/?api=1&query=Lago+Jasna+Kranjska+Gora+Slovenia',
  zelenci: 'https://www.google.com/maps/search/?api=1&query=Riserva+naturale+Zelenci+Podkoren+Slovenia',
  tamar: 'https://www.google.com/maps/search/?api=1&query=Val+Tamar+Planica+Slovenia',
  fusine: 'https://www.google.com/maps/search/?api=1&query=Laghi+di+Fusine+Tarvisio',
  vrsic: 'https://www.google.com/maps/search/?api=1&query=Passo+Vrsic+Slovenia',
  izvirSoce: 'https://www.google.com/maps/search/?api=1&query=Izvir+Soce+Slovenia',
  velikaKorita: 'https://www.google.com/maps/search/?api=1&query=Velika+korita+Soce+Slovenia',
  vintgar: 'https://www.google.com/maps/search/?api=1&query=Gola+di+Vintgar+Slovenia',
  bled: 'https://www.google.com/maps/search/?api=1&query=Lago+di+Bled+Slovenia',
  vogel: 'https://www.google.com/maps/search/?api=1&query=Funivia+Vogel+Ukanc+Slovenia',
  bohinj: 'https://www.google.com/maps/search/?api=1&query=Lago+di+Bohinj+Slovenia',
  pericnik: 'https://www.google.com/maps/search/?api=1&query=Cascata+Pericnik+Mojstrana+Slovenia',
  kozjak: 'https://www.google.com/maps/search/?api=1&query=Cascata+Kozjak+Kobarid+Slovenia',
  radovljica: 'https://www.google.com/maps/search/?api=1&query=Radovljica+Slovenia',
  ljubljana: 'https://www.google.com/maps/search/?api=1&query=Castello+di+Lubiana+Slovenia',
  velikaPlanina: 'https://www.google.com/maps/search/?api=1&query=Velika+Planina+Slovenia',
  postumia: 'https://www.google.com/maps/search/?api=1&query=Grotte+di+Postumia+Slovenia',
  predjama: 'https://www.google.com/maps/search/?api=1&query=Castello+di+Predjama+Slovenia',
  snovik: 'https://www.google.com/maps/search/?api=1&query=Terme+Snovik+Slovenia',
  logar: 'https://www.google.com/maps/search/?api=1&query=Logarska+dolina+Slovenia',
  piran: 'https://www.google.com/maps/search/?api=1&query=Piran+Slovenia',
  brvBrjeka: 'https://www.google.com/maps/search/?api=1&query=Brv+Brjeka+Bovec+Slovenia',
  brvJablanca: 'https://www.google.com/maps/search/?api=1&query=Brv+Jablanca+Bovec+Slovenia',
  pokljukaGorge: 'https://www.google.com/maps/search/?api=1&query=Pokljuka+Gorge+Slovenia',
  beerFountainZalec: 'https://www.google.com/maps/search/?api=1&query=Green+Gold+Beer+Fountain+Zalec+Slovenia',
  wineFountainMarezige: 'https://www.google.com/maps/search/?api=1&query=Vinska+fontana+Marezige+Slovenia',
  ostarijaKg: 'https://www.google.com/maps/search/?api=1&query=Ostarija+Kranjska+Gora+Borovska+102b',
  gostilnaVintgar: 'https://www.google.com/maps/search/?api=1&query=Gostilna+Vintgar+Podhom+Slovenia',
  ladra: 'https://www.google.com/maps/search/?api=1&query=Ladra+Kobarid+Slovenia',
  kozjakViewpoint: 'https://www.google.com/maps/search/?api=1&query=Slap+Kozjak+viewpoint+Kobarid',
  lagoSuperioreFusine: 'https://www.google.com/maps/search/?api=1&query=Lago+Superiore+Fusine+Tarvisio',
  slapVirje: 'https://www.google.com/maps/search/?api=1&query=Slap+Virje+Bovec+Slovenia',
  parkingVrsic: 'https://www.google.com/maps/search/?api=1&query=Parcheggio+Passo+Vrsic+Slovenia',
  parkingVintgar: 'https://www.google.com/maps/search/?api=1&query=Parcheggio+Vintgar+Podhom+P1',
  parkingVogel: 'https://www.google.com/maps/search/?api=1&query=Parcheggio+Funivia+Vogel+Ukanc',
  parkingFusine: 'https://www.google.com/maps/search/?api=1&query=Parcheggio+Lago+Superiore+Fusine',
  parkingLogar: 'https://www.google.com/maps/search/?api=1&query=Parcheggio+Logarska+dolina+Solcava',
  mostnica: 'https://www.google.com/maps/search/?api=1&query=Gola+Mostnica+Stara+Fuzina+Slovenia',
};

function mapsCoords(lat, lng) {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}

export const slovenia2026 = {
  trip: {
    title: 'Slovenia 2026, in famiglia',
    country: 'Slovenia',
    dateStart: '2026-06-28',
    dateEnd: '2026-07-12',
    party: { adults: 2, children: [{ age: 12 }, { age: 7 }] },
  },

  /** Alloggi del gruppo — solo seed istanza F0, non nel template Piano */
  instanceBases: [
    {
      name: 'Kranjska Gora',
      subtitle: 'Alpi Giulie · settimana 1',
      dateStart: '2026-06-28',
      dateEnd: '2026-07-05',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Kranjska+Gora+Slovenia',
      orderIdx: 0,
    },
    {
      name: 'Domžale',
      subtitle: 'Base Lubiana · settimana 2',
      dateStart: '2026-07-05',
      dateEnd: '2026-07-12',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Domzale+Slovenia',
      orderIdx: 1,
    },
  ],

  sections: {
    whereToEat: {
      intro:
        'Una selezione di gostilne (trattorie) e bistrot lungo gli itinerari, con buon rapporto qualità-prezzo e adatti alle famiglie. In Slovenia si mangia bene e a prezzi onesti: piatti tipici sono i žlikrofi (ravioli ripieni), la jota (zuppa di crauti e fagioli), i grigliati di carne, gli štruklji (rotoli di pasta ripieni, dolci o salati) e la kremšnita (torta alla crema e sfoglia, specialità di Bled). €≈ economico · €€≈ medio.',
      places: [
        { zone: 'Kranjska Gora', name: 'Gostilna Zelenci (Podkoren)', priceType: 'Tipico · €€', note: 'Gulasch, grigliate, parco giochi per i bimbi, parcheggio gratis.', mapsQuery: 'Gostilna Zelenci Podkoren Slovenia' },
        { zone: 'Kranjska Gora', name: 'Lačni Kekec', priceType: 'Grill · €€', note: 'Porzioni enormi di carne; conviene prenotare. Chiuso il mercoledì.', mapsQuery: 'Lačni Kekec Kranjska Gora' },
        { zone: 'Bled (mer 1/7)', name: 'Gostilna Pri Planincu', priceType: 'Tipico · €€', note: 'Mixed grill e gulasch della nonna, ambiente accogliente, prezzi onesti.', mapsQuery: 'Gostilna Pri Planincu Bled' },
        { zone: 'Vintgar / Bled (mer 1/7)', name: 'Gostilna Vintgar (Podhom)', priceType: 'Tipico · €€', note: 'Storica gostilna all\'ingresso della gola; terrazza e parcheggio. Comoda prima o dopo Vintgar.', mapsQuery: 'Gostilna Vintgar Podhom Slovenia' },
        { zone: 'Kranjska Gora', name: 'Restaurant Oštarija', priceType: 'Europeo · €€', note: 'Grill, risotti e terrazza; prenotazione consigliata in alta stagione.', mapsQuery: 'Ostarija Kranjska Gora Borovska' },
        { zone: 'Bohinj (ven 3/7)', name: 'Restavracija Pri Lovcu (Ribčev Laz)', priceType: 'Tipico · €€', note: 'Apre il pomeriggio.', mapsQuery: 'Restavracija Pri Lovcu Ribčev Laz Bohinj' },
        { zone: 'Valle Soča (gio 2/7)', name: 'Gostišče Sovdat (Bovec)', priceType: 'Tipico · €€', note: 'Jota, trota fritta, dolci locali; riparo perfetto se piove. Chiuso mer-gio.', mapsQuery: 'Gostišče Sovdat Bovec' },
        { zone: 'Postumia (mer 8/7)', name: 'Bistro Štorja', priceType: 'Menù fisso · €€', note: 'Menù 3 portate ~36€ — indicativo, da verificare. Ottimo, piatto bimbi. Chiuso domenica.', mapsQuery: 'Bistro Štorja Postojna' },
        { zone: 'Postumia', name: 'Ob kaminu', priceType: 'Tipico · €€', note: 'Cinghiale e dolci fatti in casa, buon rapporto qualità-prezzo. Vicino a Predjama, opzioni per bambini e piccolo regalo ai piccoli.', mapsQuery: 'Ob kaminu Postojna Slovenia' },
        { zone: 'Kamnik (mar 7/7)', name: 'Korobač', priceType: 'Bistrot · €', note: 'Pranzo veloce e vario nel centro storico, staff che parla inglese.', mapsQuery: 'Korobač Kamnik' },
        { zone: 'Lubiana (lun 6/7)', name: 'Klobasarna', priceType: 'Street food · €', note: 'La salsiccia carniolana e la jota a pochi euro, in pieno centro.', mapsQuery: 'Klobasarna Ljubljana' },
        { zone: 'Lubiana', name: "Čevabdžinica Sarajevo '84", priceType: 'Balcanico · €', note: "Ćevapi e porzioni abbondanti, economico; spesso c'è coda.", mapsQuery: 'Čevabdžinica Sarajevo 84 Ljubljana' },
        { zone: 'Piran (sab 11/7)', name: 'Pirat Piran', priceType: 'Pesce · €€', note: 'Pesce fresco e pasta ai frutti di mare con vista; buon prezzo/qualità.', mapsQuery: 'Pirat Piran restaurant' },
      ],
      footer:
        'A luglio nei posti più gettonati conviene prenotare o arrivare presto. Molti locali fanno pausa pomeridiana e alcuni chiudono 1-2 giorni a settimana: controllate gli orari. Prezzi indicativi, da verificare sul posto.',
    },

    rainPlanB: `Tra fine giugno e luglio in montagna i temporali pomeridiani sono frequenti. Ecco le alternative al coperto, divise per base. Regola d'oro alpina: si parte presto, si scende prima del primo pomeriggio.

**Settimana 1 — zona Kranjska Gora**
- Grotte di Postumia anticipate qui (al coperto, ottime con pioggia) se il meteo gira.
- Museo dell'apicoltura di Radovljica e centro storico coperto; museo di Bled al castello.
- Aquapark / piscine coperte a Kranjska Gora o terme di Bled per far sfogare i bimbi.
- Le gole (Vintgar, Velika korita) e le cascate (Peričnik) restano belle anche con pioggia leggera e impermeabile — ma evitatele con temporali forti per rischio piena.
- Ripiego goloso: giro delle gostilne (le trattorie locali) per assaggiare gli štruklji (rotoli di pasta ripieni, dolci o salati) e la kremšnita (la torta alla crema e sfoglia tipica di Bled).

**Settimana 2 — zona Lubiana**
- Lubiana: castello, musei (Museo Nazionale, museo delle illusioni — piace ai ragazzi), gallerie, mercato coperto.
- Grotte di Postumia + Castello di Predjama: la gita perfetta per un giorno di pioggia.
- Terme Snovik: piscine coperte, da spostare qui se il meteo è brutto.
- Acquario di Piran o un pranzo lungo di pesce se la costa è bagnata.

Scaricate l'app meteo ARSO (servizio meteo sloveno) per le previsioni locali e i radar dei temporali.`,

    quickPick: `Quando non sai cosa fare adesso, parti da qui: trova la situazione e hai la risposta pronta.

| Se... | Allora → |
|---|---|
| Avete solo mezza giornata | Lago Jasna · Zelenci · Cascata Peričnik (tutte brevi e vicine alla base sett. 1) |
| Fa caldo, voglia di bagno | Lago di Bohinj · Lago Jasna · mare a Piran · in alternativa Terme Snovik |
| Bimbi stanchi, tappa corta | Zelenci (~15 min) — indicativo, da verificare · Peričnik (~15 min) — indicativo, da verificare · giro parziale di un lago |
| Voglia di camminare sul serio | Val Tamar · sentieri del Soča · Vogel in quota · Valle di Logar |
| Giornata "no" / solo relax | Terme Snovik · lungolago di Bled con kremšnita · centro di Lubiana |
| Piove | Grotte, musei, terme coperte (vedi sezione piano B pioggia) |
| Cultura e storia | Lubiana e il castello · Predjama · mura e borgo di Piran |
| Effetto "wow" garantito | Passo Vršič + gola del Soča · Grotte di Postumia · Lago di Bled |
| Pranzo al volo e buono | Klobasarna o Sarajevo '84 (Lubiana) · Korobač (Kamnik) · panino al sacco |

**🚁 Drone — promemoria per pilota registrato (UE/EASA)**
La registrazione operatore e il codice ID UE valgono anche in Slovenia: marca il drone col codice, resta sotto i 120 m, a vista, mai sopra le persone, solo di giorno. Verifica ogni volo sull'app ufficiale "Slovenia Drone".

**VIETATO** (Parco del Triglav, salvo permesso dell'ente): Kranjska Gora e dintorni, Zelenci, Val Tamar, Vršič, valle del Soča, Vintgar, Bled, Bohinj, Vogel, Peričnik, Kozjak. Multe €200–2.500 — indicativo, da verificare e confisca; controllano anche i social.

**POSSIBILE** (fuori dal parco, ma sempre da verificare): Laghi di Fusine — area protetta italiana, regolamento locale del parco; Valle di Logar e Velika Planina — fuori dal Triglav ma zone tutelate/pascoli; Piran — fuori parco ma occhio al centro abitato e all'aeroporto di Portorož. Decidi sul posto con l'app, non a priori.

**Menu sentieri della Valle del Soča (Isonzo)**
La valle del Soča è un paradiso di passeggiate panoramiche lungo l'acqua color smeraldo. Quasi tutte facili e adatte ai bimbi. Si raggiunge da Kranjska Gora valicando il Passo Vršič.

1. **Sentiero del Soča (da Trenta)** — facile · pianeggiante · tratti da 1–3 km — indicativo, da verificare · 🚗 ~45 min da base — indicativo, da verificare
2. **Sorgente dell'Isonzo (Izvir Soče)** — breve ma ultimo tratto attrezzato con corda · ⚠️ non adatto ai piccoli (fermarsi al belvedere) · € gratis — indicativo, da verificare
3. **Grande Gola del Soča (Velika korita)** — facile · lungofiume 1–2 km — indicativo, da verificare · ponti sospesi · € parcheggio ~€5 — indicativo, da verificare
4. **Piccola Gola (Mala korita) e ponti di Trenta** — facilissimo · 10–20 min — indicativo, da verificare · vicino alla strada · € gratis — indicativo, da verificare
5. **Cascata Boka** — salita di ~20–30 min al belvedere — indicativo, da verificare · media · 🚗 più a valle (verso Bovec) — indicativo, da verificare
6. **Kobarid: Ponte di Napoleone + cascata Kozjak + Sentiero della Pace** — facile-media · ~1h al Kozjak — indicativo, da verificare · € museo a parte — indicativo, da verificare
7. **Cascata Virje (Slap Virje)** — facile · ~20–30 min in discesa — indicativo, da verificare · 🚗 strada stretta — indicativo, da verificare · € parcheggio — indicativo, da verificare
8. **Chiesa di Sant'Antonio (Kobarid) & Chiesa di Javorca** — storia WWI · viste panoramiche · ⚠️ Javorca: accesso con navetta da Tolmin — indicativo, da verificare

**Tappe extra (dalla lista Google Maps)**

*Zona settimana 1 — Bohinj / Pokljuka:* Gola di Mostnica (ora tappa opzionale giorno Vogel/Bohinj) · Cascata Savica (~20 min, 558 gradini — indicativo, da verificare · € ingresso — indicativo, da verificare) · Planina Zajamniki (~1 h facile — indicativo, da verificare)

*Zona settimana 1 — Valle del Soča & Tarvisio:* Slap Virje (ora tappa opzionale giorno Vršič/Soča) · Chiesa di Sant'Antonio sopra Kobarid · Chiesa di Javorca (⚠️ bus-navetta da Tolmin ~2€ — indicativo, da verificare) · Orrido dello Slizza (Tarvisio, anello ~3 km — indicativo, da verificare, abbinabile ai Laghi di Fusine)

*Zona settimana 2 — Kamnik / Savinja:* Repov slap (Luče, ~10–30 min — indicativo, da verificare) · Castello di Zaprice (Kamnik, mar–sab 10–18 — indicativo, da verificare) · Castello di Jable (Mengeš, ~10 min da Domžale — indicativo, da verificare)

*Opzionali / fuori rotta:* Valle dei Sette Laghi del Triglav (⚠️ non adatto a 7 anni) · Gola di Pokljuka · Ponte di Salcano · Hiša Franko · Castello di Žovnek · Certosa di Žiče · Cerkev Sv. Tomaž · Castello di Ptuj · Fontana della birra di Žalec · Vinska fontana Marezige`,

    fuel: `Stima carburante & pedaggi per Ford Kuga full hybrid a benzina.

| Voce | Stima |
|---|---|
| Consumo reale Kuga FHEV (misto/montagna) | ~6–6,5 L/100 km — indicativo, da verificare |
| Prezzo benzina in Slovenia (giu 2026) | ~1,71 €/L — indicativo, da verificare (fuori autostrada) |
| Km stimati nelle 2 settimane | ~700–900 km — indicativo, da verificare (escluso viaggio da/per casa) |
| Litri stimati | ~44–58 L — indicativo, da verificare |
| Spesa carburante in loco | ~75–100 € — indicativo, da verificare |
| Vignetta autostradale | 16 € (settimanale) o 32 € (mensile) — indicativo, da verificare |
| Parcheggi (laghi, gole, città) | ~40–60 € totali — indicativo, da verificare (€5–10 a tappa, app EasyPark) |
| **Totale auto in loco (indicativo)** | **~130–175 € — indicativo, da verificare** |

L'ibrido vi avvantaggia parecchio nei tornanti e nel traffico lento (es. salita/discesa del Vršič, code estive ai laghi). In autostrada il carburante costa di più: fate il pieno nelle stazioni fuori dalle autostrade, dove i prezzi sono calmierati. Prezzi aggiornati a giugno 2026 — indicativo, da verificare, variano ogni 1–2 settimane.

**Info utili**
- Emergenze: 112 · Polizia: 113
- Prefisso: +386 (Slovenia) · +39 (Italia, per Fusine)
- Valuta: Euro · Fuso orario: stesso dell'Italia
- Acqua potabile dai rubinetti e dalle fontane di montagna
- Negozi/supermercati: spesso chiusi o orario ridotto la domenica (fate spesa il sabato)
- App: ARSO (meteo) · Slovenia Drone (zone volo) · PZS (sentieri) · EasyPark (parcheggi)

**Nello zaino per le camminate coi bimbi**
Scarpe chiuse · giacca antipioggia leggera · 1,5–2 L d'acqua a testa · snack/barrette · cappellino e crema solare · spray antizanzare · piccolo kit pronto soccorso · costume e asciugamano · felpa anche d'estate (grotte 8–10 °C) · contanti per i rifugi.`,

    slovenePhrases: [
      { slovene: 'Dober dan', italian: 'Buongiorno', note: null },
      { slovene: 'Živjo', italian: 'Ciao', note: null },
      { slovene: 'Hvala', italian: 'Grazie', note: null },
      { slovene: 'Prosim', italian: 'Per favore / prego', note: null },
      { slovene: 'Koliko stane?', italian: 'Quanto costa?', note: null },
      { slovene: 'Voda', italian: 'Acqua', note: null },
      { slovene: 'Pivo', italian: 'Birra', note: null },
      { slovene: 'Kje je...?', italian: 'Dov\'è...?', note: null },
      { slovene: 'Da / Ne', italian: 'Sì / No', note: null },
      { slovene: 'Na pomoč!', italian: 'Aiuto!', note: null },
      { slovene: 'Račun, prosim', italian: 'Il conto, per favore', note: null },
      { slovene: 'Stranišče', italian: 'Bagno / WC', note: null },
    ],

    ticketsSummary: [
      { name: 'Gola di Vintgar', costInfo: '~€28 famiglia — indicativo, da verificare', note: 'Online in anticipo (orario fisso) · vintgar.si', bookingUrl: 'https://www.vintgar.si' },
      { name: 'Grotte Postumia + Predjama (combinato)', costInfo: '~€130 famiglia — indicativo, da verificare', note: 'Online in anticipo · postojnska-jama.eu', bookingUrl: 'https://www.postojnska-jama.eu' },
      { name: 'Funivia Vogel', costInfo: '~€90 famiglia — indicativo, da verificare', note: 'Consigliato online (code) · vogel.si', bookingUrl: 'https://www.vogel.si' },
      { name: 'Velika Planina (funivia+seggiovia)', costInfo: '~€65 famiglia — indicativo, da verificare', note: 'In loco o online · velikaplanina.si', bookingUrl: 'https://www.velikaplanina.si' },
      { name: 'Lubiana: castello + funicolare', costInfo: '~€40 famiglia — indicativo, da verificare', note: 'In loco o online · ljubljanskigrad.si', bookingUrl: 'https://www.ljubljanskigrad.si' },
      { name: 'Terme Snovik (ingresso giornaliero)', costInfo: '~€60 famiglia — indicativo, da verificare', note: 'In loco · terme-snovik.si', bookingUrl: 'https://www.terme-snovik.si' },
      { name: 'Barca "pletna" Bled (opzionale)', costInfo: '~€60 famiglia — indicativo, da verificare', note: 'In loco al pontile · riva del lago' },
      { name: 'Cascata Kozjak (se fatta)', costInfo: '~€12 famiglia — indicativo, da verificare', note: 'In loco · cassa Kobarid' },
      { name: 'Valle di Logar', costInfo: '~€10 famiglia — indicativo, da verificare', note: 'In loco (casello auto) · ingresso valle' },
      { name: 'Piran: mura cittadine', costInfo: '~€10 famiglia — indicativo, da verificare', note: 'In loco · ingresso mura' },
      { name: 'Vignetta autostradale Slovenia (1 settimana)', costInfo: '~€16 — indicativo, da verificare', note: 'Online prima di entrare · evinjeta.dars.si', bookingUrl: 'https://evinjeta.dars.si' },
      { name: 'Parcheggi vari (laghi, gole, Fusine…)', costInfo: '~€40–60 totali — indicativo, da verificare', note: 'In loco (app EasyPark)' },
      { name: 'Totale "completo" (con extra opzionali)', costInfo: '~€500–580 — indicativo, da verificare', note: 'Tutto incluso' },
      { name: 'Totale "low-budget"', costInfo: '~€300–350 — indicativo, da verificare', note: 'Salta pletna + 1 funivia' },
    ],
  },

  days: [
    {
      date: '2026-06-28',
      dayType: 'water',
      title: 'Arrivo + Lago Jasna',
      ritmo: 'Arrivo e check-in nel pomeriggio · tardo pom. due passi al lago e bagno · sera spesa al supermercato e cena tranquilla in appartamento.',
      orderIdx: 0,
      stops: [
        {
          name: 'Lago Jasna',
          description:
            'Laghetto alpino tra le montagne sopra Kranjska Gora: acqua turchese, chiesetta di legno e sentiero pianeggiante. Perfetto per un primo giro dopo l\'arrivo, anche al tramonto.',
          carTime: '🚗 in paese · 5 min — indicativo, da verificare',
          walkInfo: '🥾 giro ~1,5 km · facile · 30–45 min — indicativo, da verificare',
          costInfo: '€ gratis (parcheggio €2–5) — indicativo, da verificare',
          mapsUrl: MAPS.jasna,
          lat: 46.471,
          lng: 13.7875,
          warning: null,
          orderIdx: 0,
        },
      ],
    },
    {
      date: '2026-06-29',
      dayType: 'nature',
      title: 'Zelenci + Val Tamar',
      ritmo: 'Mattina presto Zelenci (breve) poi camminata in Val Tamar fino al rifugio · pranzo al sacco o al rifugio · rientro primo pomeriggio, relax in paese.',
      orderIdx: 1,
      stops: [
        {
          name: 'Riserva naturale Zelenci',
          description:
            'Sorgenti di acqua color smeraldo che alimentano la Sava Dolinka: passerella nel bosco tra canneti e ruscelli. Ambiente fresco e silenzioso — meglio al mattino presto.',
          carTime: '🚗 ~6 km · 10 min — indicativo, da verificare',
          walkInfo: '🥾 passerella ~10–15 min A/R · facilissimo — indicativo, da verificare',
          costInfo: '€ gratis — indicativo, da verificare',
          mapsUrl: MAPS.zelenci,
          lat: 46.465,
          lng: 13.6945,
          warning: null,
          orderIdx: 0,
        },
        {
          name: 'Val Tamar (rifugio)',
          description:
            'Valle del Planica con sentiero nel bosco verso il rifugio Tamar (Planinski dom Tamar), ai piedi delle cime giuliane; sul percorso si passa dalla Kapela Marije Pomagaj. Panorama sulle montagne; pranzo al sacco o al rifugio con piatti semplici.',
          carTime: '🚗 ~7 km · 12 min (Planica) — indicativo, da verificare',
          walkInfo: '🥾 ~3 km a tratta · facile, lieve salita · 45–60 min — indicativo, da verificare',
          costInfo: '€ gratis · pranzo al rifugio (contanti) — indicativo, da verificare',
          mapsUrl: MAPS.tamar,
          lat: 46.475,
          lng: 13.7265,
          warning: null,
          orderIdx: 1,
        },
      ],
    },
    {
      date: '2026-06-30',
      dayType: 'water',
      title: 'Laghi di Fusine (Italia)',
      ritmo: 'Mattina anello dei due laghi (ombreggiato, fresco) · pranzo al sacco sulle panchine o baretto · pomeriggio rientro presto, tempo libero/relax a Kranjska Gora. Tappa extra in zona: Orrido dello Slizza a Tarvisio (gola con passerelle, ~3 km — indicativo, da verificare, gratis) si abbina benissimo a questa giornata.',
      orderIdx: 2,
      stops: [
        {
          name: 'Lago Superiore e Inferiore (Laghi di Fusine)',
          description:
            'Due laghi italiani a pochi km dal confine: acqua turchese, anello ombreggiato tra abeti e cime (sentiero del Lago Superiore e del Lago Inferiore). Fresco anche d\'estate; ideale per pranzo al sacco sulle panchine.',
          carTime: '🚗 ~13 km · 20 min (Tarvisio) — indicativo, da verificare',
          walkInfo: '🥾 anello lago sup. ~2 km · entrambi ~4–5 km · 1–2 h — indicativo, da verificare',
          costInfo: '€ parcheggio ~€5/giorno — indicativo, da verificare',
          mapsUrl: MAPS.fusine,
          lat: 46.47528,
          lng: 13.65735,
          warning: '🅿️ Parcheggio Lago Superiore (trailhead anello) — arrivo presto in alta stagione. Niente bagno in lago.',
          orderIdx: 0,
        },
      ],
    },
    {
      date: '2026-07-01',
      dayType: 'water',
      title: 'Gola di Vintgar + Lago di Bled',
      ritmo: 'Presto a Vintgar all\'orario prenotato (parcheggio P1 Podhom, poi 5 min a piedi) · pranzo a Bled (provate la kremšnita) · pomeriggio giro del lago/barca · rientro nel tardo pomeriggio.',
      orderIdx: 3,
      stops: [
        {
          name: '🅿️ Parcheggio Vintgar (P1 Podhom)',
          description:
            'Parcheggio ufficiale all\'ingresso della gola: 5 min a piedi dalla biglietteria. Arrivate 20 min prima dell\'orario prenotato; in alta stagione si riempie.',
          carTime: '🚗 ~43 km da KG · seguire cartelli Vintgar — indicativo, da verificare',
          walkInfo: '🥾 ~5 min fino all\'ingresso gola — indicativo, da verificare',
          costInfo: '€ ~€5 · EasyPark o contanti — indicativo, da verificare',
          mapsUrl: MAPS.parkingVintgar,
          lat: 46.39217,
          lng: 14.08594,
          warning: null,
          orderIdx: 0,
        },
        {
          name: 'Gola di Vintgar',
          description:
            'Canyon con passerelle di legno sospese sopra cascate e torrenti. Casco obbligatorio, percorso a senso unico — prenotate l\'orario e andateci al mattino presto.',
          carTime: '🚗 ~43 km · 40 min — indicativo, da verificare',
          walkInfo: '🥾 1,6 km su passerelle · facile · ~1 h (casco) — indicativo, da verificare',
          costInfo: '€ adulto ~€10 · bimbo ~€5 · da prenotare — indicativo, da verificare',
          mapsUrl: MAPS.vintgar,
          lat: 46.3915,
          lng: 14.0888,
          warning: 'Andateci la mattina presto, all\'orario prenotato. Vicino: Gostilna Vintgar (Podhom) per pranzo.',
          orderIdx: 1,
        },
        {
          name: 'Lago di Bled',
          description:
            'Il classico sloveno: isola con chiesetta, campanile e castello sulla rupe. Giro del lago a piedi o barca pletna tradizionale; in pasticceria ordinate la kremšnita.',
          carTime: '🚗 ~8 km dalla gola · 12 min — indicativo, da verificare',
          walkInfo: '🥾 giro ~6 km piano · 1,5–2 h (anche parziale) — indicativo, da verificare',
          costInfo: '€ barca pletna ~€18/p · castello ~€15 (opz.) — indicativo, da verificare',
          mapsUrl: MAPS.bled,
          lat: 46.3662,
          lng: 14.108,
          warning: 'Isola con chiesetta, castello sulla rupe. Provate la "kremšnita".',
          orderIdx: 2,
        },
      ],
    },
    {
      date: '2026-07-02',
      dayType: 'nature',
      title: 'Passo Vršič + Sorgente Isonzo + Gola del Soča',
      ritmo: 'Partenza presto per il Vršič (parcheggi pieni a metà mattina) · soste ai belvedere e alla sorgente · pranzo al sacco in valle · pomeriggio gola del Soča · opzionale Slap Virje se avanza tempo · rientro per cena. Vedi anche "Menu sentieri del Soča".',
      orderIdx: 4,
      stops: [
        {
          name: '🅿️ Parcheggio Passo Vršič (cima)',
          description:
            'Parcheggi lungo la salita e in cima al passo (1.611 m): partite presto — a metà mattina sono spesso pieni. Sosta consigliata alla Cappella Russa in salita.',
          carTime: '🚗 50 tornanti da KG · partenza entro le 8 — indicativo, da verificare',
          walkInfo: null,
          costInfo: '€ ~€5 a sosta · contanti — indicativo, da verificare',
          mapsUrl: MAPS.parkingVrsic,
          lat: 46.4292,
          lng: 13.7358,
          warning: null,
          orderIdx: 0,
        },
        {
          name: 'Passo Vršič (1.611 m) → Trenta',
          description:
            'Il passo stradale più alto delle Alpi Giulie: 50 tornanti tra pareti rocciose e panorami a 360°. Soste ai belvedere e alla Cappella Russa — partite presto per i parcheggi.',
          carTime: '🚗 50 tornanti · ~35 km · 1h–1h15 — indicativo, da verificare',
          walkInfo: '🥾 belvedere e soste in salita — indicativo, da verificare',
          costInfo: '€ gratis (parcheggi €5) — indicativo, da verificare',
          mapsUrl: MAPS.vrsic,
          lat: 46.4286,
          lng: 13.7369,
          warning: 'Sosta alla Cappella Russa (Russian Chapel) in salita.',
          orderIdx: 1,
        },
        {
          name: 'Sorgente dell\'Isonzo (Izvir Soče)',
          description:
            'Piccola sorgente dove l\'Isonzo nasce da una grotta nel massiccio: acqua turchese in un anfiteatro di roccia. Belvedere facile; il tratto con corda è solo per escursionisti esperti.',
          carTime: '🚗 in valle del Soča — indicativo, da verificare',
          walkInfo: '🥾 belvedere ~20 min — indicativo, da verificare',
          costInfo: '€ gratis — indicativo, da verificare',
          mapsUrl: MAPS.izvirSoce,
          lat: 46.33688,
          lng: 13.73452,
          warning: '⚠️ All\'Izvir Soče l\'ultimo tratto con corda metallica non è adatto ai bambini: fermatevi al belvedere.',
          orderIdx: 2,
        },
        {
          name: 'Grande Gola del Soča (Velika korita)',
          description:
            'Le gole scavate dal fiume nel marmo verde: sentiero lungo il corso d\'acqua tra pareti a picco. Spettacolare soprattutto dopo pioggia, quando l\'acqua è più impetuosa.',
          carTime: '🚗 in valle — indicativo, da verificare',
          walkInfo: '🥾 lungofiume 1–2 km — indicativo, da verificare',
          costInfo: '€ gratis (parcheggi €5) — indicativo, da verificare',
          mapsUrl: MAPS.velikaKorita,
          lat: 46.3462,
          lng: 13.6524,
          warning: null,
          orderIdx: 3,
        },
        {
          name: 'Slap Virje — tappa opzionale',
          description:
            'Cascata emerald a breve discesa dal parcheggio: strada stretta verso Plužna, ~20–30 min A/R. Solo se avanza tempo dopo Velika korita — altrimenti saltate.',
          carTime: '🚗 ~15 km da Velika korita verso Bovec — indicativo, da verificare',
          walkInfo: '🥾 ~20–30 min discesa/risalita · facile — indicativo, da verificare',
          costInfo: '€ parcheggio a pagamento — indicativo, da verificare',
          mapsUrl: MAPS.slapVirje,
          lat: 46.3606,
          lng: 13.2831,
          warning: 'Strada stretta e parcheggio piccolo: valutate sul posto con i bimbi.',
          orderIdx: 4,
        },
      ],
    },
    {
      date: '2026-07-03',
      dayType: 'water',
      title: 'Funivia Vogel + Lago di Bohinj',
      ritmo: 'Mattina funivia Vogel (parcheggio Ukanc, primi turni) e passeggiata in quota · pranzo al sacco/baita · pomeriggio bagno al lago di Bohinj · opzionale Gola di Mostnica se in forma · rientro per cena.',
      orderIdx: 5,
      stops: [
        {
          name: 'Funivia Vogel (1.535 m)',
          description:
            'Salita in quota sopra il lago di Bohinj: prati alpini, vista sul Triglav e mucche al pascolo. Sentieri facili in cima — i primi turni evitano le code.',
          carTime: '🚗 ~57 km · 55 min (Ukanc) — indicativo, da verificare',
          walkInfo: '🥾 sentieri facili in quota tra i prati — indicativo, da verificare',
          costInfo: '€ adulto ~€33 A/R · ridotti bimbi — indicativo, da verificare',
          mapsUrl: MAPS.vogel,
          lat: 46.2789,
          lng: 13.8361,
          warning: '🅿️ Parcheggio funivia Vogel (Ukanc) — grande, ma code mattina: primi turni. Vista a 360° su lago e Triglav.',
          orderIdx: 0,
        },
        {
          name: 'Lago di Bohinj',
          description:
            'Il lago naturale più grande della regione: spiaggette d\'erba, acqua fresca e meno affollato di Bled. Perfetto per pomeriggio di bagno e relax.',
          carTime: '🚗 ~3 km dalla funivia — indicativo, da verificare',
          walkInfo: '🥾 spiaggette d\'erba, lungolago piano — indicativo, da verificare',
          costInfo: '€ gratis · canoa/SUP (opz.) — indicativo, da verificare',
          mapsUrl: MAPS.bohinj,
          lat: 46.2775,
          lng: 13.885,
          warning: 'Più tranquillo di Bled e ottimo per il bagno.',
          orderIdx: 1,
        },
        {
          name: 'Gola di Mostnica — tappa opzionale',
          description:
            'Gola con ponticelli di legno e cascatelle nel bosco sopra Stara Fužina: anello ~1 h nel verde. Solo se avete energia dopo Vogel/Bohinj — altrimenti saltate.',
          carTime: '🚗 ~5 km da Ribčev Laz — indicativo, da verificare',
          walkInfo: '🥾 anello ~3 km · facile · ~1 h — indicativo, da verificare',
          costInfo: '€ ingresso ~€3 adulto — indicativo, da verificare',
          mapsUrl: MAPS.mostnica,
          lat: 46.3085,
          lng: 13.7895,
          warning: 'Sentiero nel bosco con ponticelli — bello ma opzionale rispetto al programma base.',
          orderIdx: 2,
        },
      ],
    },
    {
      date: '2026-07-04',
      dayType: 'relax',
      title: 'Peričnik / Kozjak / relax',
      ritmo: 'Giornata libera/morbida · mattina cascata Peričnik (corta) oppure gita più lunga a Kozjak se in forma · pomeriggio relax, valigie e ultima sera a Kranjska Gora.',
      orderIdx: 6,
      stops: [
        {
          name: 'Cascata Peričnik (Mojstrana)',
          description:
            'Cascata nel parco del Triglav con sentiero breve: si passa dietro il getto d\'acqua in una nicchia rocciosa. I bambini la adorano — portate un asciugamano.',
          carTime: '🚗 ~12 km · 15 min — indicativo, da verificare',
          walkInfo: '🥾 ~10–15 min · si cammina dietro la cascata — indicativo, da verificare',
          costInfo: '€ gratis (parcheggio €2–3) — indicativo, da verificare',
          mapsUrl: MAPS.pericnik,
          lat: 46.4612,
          lng: 13.9138,
          warning: 'Mezza giornata leggera, i bimbi adorano passare dietro l\'acqua.',
          orderIdx: 0,
        },
        {
          name: 'Cascata Kozjak (Kobarid) — gita lunga opzionale',
          description:
            'Cascata nascosta in una grotta-anfiteatro nella valle dell\'Isonzo: sentiero nel bosco e ponticelli di legno fino al viewpoint sulla cascata (Waterfall Kozjak). Gita più lunga se volete chiudere il cerchio del Soča.',
          carTime: '🚗 ~55 km via Vršič · 1h30 — indicativo, da verificare',
          walkInfo: '🥾 ~30–40 min a tratta nel bosco — indicativo, da verificare',
          costInfo: '€ ~€5 adulto · tariffa famiglia — indicativo, da verificare',
          mapsUrl: MAPS.kozjak,
          lat: 46.3386,
          lng: 13.6592,
          warning: 'Cascata dentro una grotta-anfiteatro. In alternativa, relax a Kranjska Gora.',
          orderIdx: 1,
        },
      ],
    },
    {
      date: '2026-07-05',
      dayType: 'transfer',
      title: 'Trasferimento a Domžale',
      ritmo: 'Trasferimento a Domžale (~80 km, ~1h — indicativo, da verificare). Sosta possibile a Radovljica (borgo storico, museo dell\'apicoltura).',
      orderIdx: 7,
      stops: [
        {
          name: 'Radovljica (sosta possibile)',
          description:
            'Borgo medievale con case lignee colorate e museo dell\'apicoltura: sosta piacevole lungo la strada verso la nuova base a Domžale, alle porte di Lubiana.',
          carTime: '🚗 ~80 km totali trasferimento · ~1h — indicativo, da verificare',
          walkInfo: '🥾 borgo storico a piedi — indicativo, da verificare',
          costInfo: '€ gratis (museo a parte) — indicativo, da verificare',
          mapsUrl: MAPS.radovljica,
          lat: 46.3442,
          lng: 14.1742,
          warning: 'Museo dell\'apicoltura. Base 2: Domžale (Lubiana).',
          orderIdx: 0,
        },
      ],
    },
    {
      date: '2026-07-06',
      dayType: 'city',
      title: 'Lubiana',
      ritmo: 'Mattina centro storico e funicolare al castello (fresco e meno affollato) · pranzo in centro (Klobasarna o Sarajevo \'84) · pomeriggio mercato, lungofiume, gelato · rientro libero.',
      orderIdx: 8,
      stops: [
        {
          name: 'Centro storico (Piazza Prešeren, Ponte dei Draghi) + Castello',
          description:
            'Capitale verde e pedonale: ponte iconico, mercato sul fiume Ljubljanica, gelato e funicolare al castello con vista sulla città. Mostre interattive adatte alle famiglie.',
          carTime: '🚗 ~18 km · 25 min (o treno) — indicativo, da verificare',
          walkInfo: '🥾 città a piedi · funicolare al castello — indicativo, da verificare',
          costInfo: '€ castello+funicolare ~€16 adulto · biglietti famiglia — indicativo, da verificare',
          mapsUrl: MAPS.ljubljana,
          lat: 46.049,
          lng: 14.5084,
          warning: 'Cuore pedonale, mercato, gelato lungo il fiume. Torre panoramica e mostra interattiva di storia, family-friendly.',
          orderIdx: 0,
        },
      ],
    },
    {
      date: '2026-07-07',
      dayType: 'nature',
      title: 'Velika Planina',
      ritmo: 'Mattina funivia+seggiovia presto, camminata tra le baite · pranzo in baita o al sacco · pomeriggio rientro, doccia e spesa · sera libera. Tappa extra sulla via: Castello di Zaprice a Kamnik (museo a misura di bimbo, mar–sab) lungo il rientro.',
      orderIdx: 9,
      stops: [
        {
          name: 'Funivia + seggiovia e villaggi dei pastori (Velika Planina)',
          description:
            'Altopiano con baite di legno dai tetti curvi: funivia e seggiovia, poi passeggiata tra prati e mucche. Una delle gite più fotogeniche vicino a Lubiana.',
          carTime: '🚗 ~25 km · 35 min — indicativo, da verificare',
          walkInfo: '🥾 passeggiate facili in quota 2–3 km — indicativo, da verificare',
          costInfo: '€ biglietto famiglia ~€65 — indicativo, da verificare',
          mapsUrl: MAPS.velikaPlanina,
          lat: 46.299,
          lng: 14.608,
          warning: 'Baite di legno caratteristiche, vista a 360°. La gita più "da cartolina" della zona di Kamnik.',
          orderIdx: 0,
        },
      ],
    },
    {
      date: '2026-07-08',
      dayType: 'city',
      title: 'Postumia + Predjama',
      ritmo: 'Mattina grotte di Postumia all\'orario prenotato (felpa!) · pranzo a Postumia (Bistro Štorja) · pomeriggio castello di Predjama · rientro nel tardo pomeriggio.',
      orderIdx: 10,
      stops: [
        {
          name: 'Grotte di Postumia (trenino)',
          description:
            'Le grotte più visitate d\'Europa: trenino sotterraneo, stalattiti giganti e il proteo, piccolo anfibio endemico. 8–10 °C: portate la felpa. Prenotate online.',
          carTime: '🚗 ~55 km · 50 min — indicativo, da verificare',
          walkInfo: '🥾 grotta: 1,5 km + trenino — indicativo, da verificare',
          costInfo: '€ combinato adulto ~€45 · bimbo ~€27 · famiglia — indicativo, da verificare',
          mapsUrl: MAPS.postumia,
          lat: 45.7825,
          lng: 14.2030,
          warning: '8–10 °C in grotta: felpa. Cercate il "proteo", il drago bianco. Voce di spesa più alta: prenotate online.',
          orderIdx: 0,
        },
        {
          name: 'Castello di Predjama (~9 km da Postumia)',
          description:
            'Castello incastonato nella roccia a strapiombo sulla valle: leggenda del cavaliere Erasmo e grotte sotto le mura. Incluso nel biglietto combinato con Postumia.',
          carTime: '🚗 ~9 km · breve — indicativo, da verificare',
          walkInfo: '🥾 castello ~1 h — indicativo, da verificare',
          costInfo: '€ incluso nel biglietto combinato — indicativo, da verificare',
          mapsUrl: MAPS.predjama,
          lat: 45.815,
          lng: 14.1267,
          warning: null,
          orderIdx: 1,
        },
      ],
    },
    {
      date: '2026-07-09',
      dayType: 'relax',
      title: 'Terme Snovik',
      ritmo: 'Giornata relax senza sveglia · mattina/pomeriggio piscine termali e scivoli con calma · pranzo leggero in loco · rientro quando volete.',
      orderIdx: 11,
      stops: [
        {
          name: 'Terme Snovik — piscine termali e scivoli',
          description:
            'Terme più vicine alla base di Domžale, in una valletta verde: piscine calde, scivoli per bambini e area relax. Giornata coccola senza sveglia.',
          carTime: '🚗 ~20 km · 30 min — indicativo, da verificare',
          walkInfo: '🥾 giornata in relax — indicativo, da verificare',
          costInfo: '€ adulto ~€16–19 · ridotti bimbi — indicativo, da verificare',
          mapsUrl: MAPS.snovik,
          lat: 46.177,
          lng: 14.9253,
          warning: 'Le terme più vicine alla base, in una valletta verde. Giornata coccola a metà settimana.',
          orderIdx: 0,
        },
      ],
    },
    {
      date: '2026-07-10',
      dayType: 'nature',
      title: 'Valle di Logar + Cascata Rinka',
      ritmo: 'Partenza presto (è la tappa più lontana) · parcheggio casello ingresso valle · mattina camminata e cascata Rinka · pranzo al sacco o in baita · pomeriggio rientro. Tappa extra sulla via: Repov slap a Luče.',
      orderIdx: 12,
      stops: [
        {
          name: '🅿️ Parcheggio ingresso Logarska dolina',
          description:
            'Casello e parcheggi all\'ingresso della valle (Solčava / trailhead Rinka): pagate l\'ingresso auto qui, poi si prosegue in valle verso la cascata.',
          carTime: '🚗 ~55 km da Domžale · 1h10 — indicativo, da verificare',
          walkInfo: null,
          costInfo: '€ ingresso auto in valle ~€10 — indicativo, da verificare',
          mapsUrl: MAPS.parkingLogar,
          lat: 46.4192,
          lng: 14.693,
          warning: null,
          orderIdx: 0,
        },
        {
          name: 'Logarska dolina e cascata Rinka',
          description:
            'Valle glaciale tra le Alpi di Kamnik: prati, fiume e cascata Rinka con belvedere a breve distanza. Una delle valli più belle del paese — baita panoramica in cima.',
          carTime: '🚗 ~55 km · 1h10 — indicativo, da verificare',
          walkInfo: '🥾 ~15 min facili al belvedere · valle piana extra — indicativo, da verificare',
          costInfo: '€ ingresso auto in valle ~€10 — indicativo, da verificare',
          mapsUrl: MAPS.logar,
          lat: 46.4065,
          lng: 14.653,
          warning: 'Una delle valli più belle delle Alpi di Kamnik, baita panoramica in cima al sentiero.',
          orderIdx: 1,
        },
      ],
    },
    {
      date: '2026-07-11',
      dayType: 'city',
      title: 'Piran (costa adriatica)',
      ritmo: 'Partenza presto per la costa · mattina centro, Piazza Tartini e mura panoramiche · pranzo di pesce (Pirat) · pomeriggio bagno in mare · rientro in serata.',
      orderIdx: 13,
      stops: [
        {
          name: 'Borgo veneziano, Piazza Tartini, mura panoramiche',
          description:
            'Perla adriatica con vicoli veneziani, tetti rossi e mura panoramiche sul mare. Piazza Tartini al centro, pranzo di pesce e tuffo in acqua nel pomeriggio.',
          carTime: '🚗 ~120 km · 1h30 — indicativo, da verificare',
          walkInfo: '🥾 vicoli a piedi · salita alle mura (gradini) — indicativo, da verificare',
          costInfo: '€ mura ~€3 adulto · bagno gratis — indicativo, da verificare',
          mapsUrl: MAPS.piran,
          lat: 45.5275,
          lng: 13.568,
          warning: 'Tetti rossi sul mare, atmosfera veneziana. Chiusura tra bagno e cena di pesce.',
          orderIdx: 0,
        },
      ],
    },
    {
      date: '2026-07-12',
      dayType: 'transfer',
      title: 'Rientro',
      ritmo: 'Buon viaggio di ritorno!',
      orderIdx: 14,
      stops: [],
    },
  ],

  checklistItems: [
    // Prenotazioni
    { itemKey: 'booking-kranjska-gora', label: 'Alloggio Kranjska Gora (28/6–5/7) ✓ prenotato', category: 'prenotazioni' },
    { itemKey: 'booking-domzale', label: 'Alloggio Domžale (5/7–12/7) ✓ prenotato', category: 'prenotazioni' },
    { itemKey: 'booking-vintgar', label: 'Vintgar — orario fisso online (mer 1/7)', category: 'prenotazioni' },
    { itemKey: 'booking-postumia-predjama', label: 'Postumia + Predjama — combinato (mer 8/7)', category: 'prenotazioni' },
    { itemKey: 'booking-vogel', label: 'Funivia Vogel — online consigliato (ven 3/7)', category: 'prenotazioni' },
    { itemKey: 'booking-velika-planina', label: 'Velika Planina — funivia+seggiovia (mar 7/7)', category: 'prenotazioni' },
    { itemKey: 'booking-cena-speciale', label: '(Opz.) cena prenotata (Lačni Kekec, Pirat…)', category: 'prenotazioni' },
    // Documenti
    { itemKey: 'docs-id', label: 'Carte d\'identità valide per l\'espatrio (x4)', category: 'documenti' },
    { itemKey: 'docs-health-card', label: 'Tessera sanitaria + TEAM retro (x4)', category: 'documenti' },
    { itemKey: 'docs-license', label: 'Patente + libretto auto', category: 'documenti' },
    { itemKey: 'docs-insurance', label: '(Opz.) assicurazione viaggio', category: 'documenti' },
    // Auto e strada
    { itemKey: 'car-check', label: 'Controllo gomme, olio, liquidi', category: 'auto' },
    { itemKey: 'car-safety-kit', label: 'Giubbotti riflettenti (x4) + triangolo', category: 'auto' },
    { itemKey: 'car-vignette', label: 'Vignetta e-vinjeta attiva prima del confine', category: 'auto' },
    { itemKey: 'car-phone-mount', label: 'Supporto telefono + cavo ricarica auto', category: 'auto' },
    // App da installare
    { itemKey: 'app-arso', label: 'ARSO (meteo + radar temporali)', category: 'app' },
    { itemKey: 'app-easypark', label: 'EasyPark (parcheggi laghi, gole, città)', category: 'app' },
    { itemKey: 'app-google-maps-offline', label: 'Google Maps offline (Slovenia + Friuli)', category: 'app' },
    { itemKey: 'app-slovenia-drone', label: 'Slovenia Drone (zone volo)', category: 'app' },
    { itemKey: 'app-metis-offline', label: 'Metis — scarica piano offline', category: 'app' },
    // Viaggio in auto (Rescaldina → Slovenia)
    { itemKey: 'travel-lunch', label: 'Pranzo al sacco preparato per la partenza', category: 'viaggio' },
    { itemKey: 'travel-snacks', label: 'Snack e bevande per l\'auto (andata + ritorno 12/7)', category: 'viaggio' },
    { itemKey: 'travel-thermos', label: '(Opz.) thermos caffè/tè per partenza mattina', category: 'viaggio' },
    // Spesa e dispensa
    { itemKey: 'shop-staples-home', label: 'Da casa: pasta, ragù, fette biscottate, acqua, latte', category: 'dispensa' },
    { itemKey: 'shop-staples-extra', label: 'Extra cucina: olio, sale, caffè, marmellata, frutta secca', category: 'dispensa' },
    { itemKey: 'shop-picnic-supplies', label: 'Bustine, pellicola, contenitori per pranzo al sacco', category: 'dispensa' },
    { itemKey: 'shop-kranjska-arrival', label: 'Spesa arrivo Kranjska Gora (28/6 sera): carne, verdura, yogurt…', category: 'dispensa' },
    { itemKey: 'shop-dishes', label: 'Detergente piatti + spugna (se non in alloggio)', category: 'dispensa' },
    { itemKey: 'shop-laundry-pods', label: 'Bustine lavatrice (per Domžale, da 5/7)', category: 'dispensa' },
    // Valigia comune
    { itemKey: 'pack-hiking-shoes', label: 'Scarpe da camminata chiuse (x4)', category: 'valigia' },
    { itemKey: 'pack-rain-jacket', label: 'Giacca antipioggia leggera (x4)', category: 'valigia' },
    { itemKey: 'pack-fleece', label: 'Felpa/pile (x4) — grotte 8–10 °C e quota', category: 'valigia' },
    { itemKey: 'pack-swimsuits', label: 'Costumi (x4)', category: 'valigia' },
    { itemKey: 'pack-towels', label: 'Asciugamani + telo mare/termo leggero', category: 'valigia' },
    { itemKey: 'pack-sunscreen', label: 'Crema solare SPF alto + cappellini (x4)', category: 'valigia' },
    { itemKey: 'pack-mosquito', label: 'Spray antizanzare', category: 'valigia' },
    { itemKey: 'pack-bottles', label: 'Borracce (x4)', category: 'valigia' },
    { itemKey: 'pack-first-aid', label: 'Kit pronto soccorso', category: 'valigia' },
    { itemKey: 'pack-daypack', label: 'Zaino da giornata', category: 'valigia' },
    { itemKey: 'pack-powerbank', label: 'Power bank + caricabatterie', category: 'valigia' },
    { itemKey: 'pack-waterproof-bag', label: 'Sacca impermeabile (telefono, pranzo)', category: 'valigia' },
    // Zaino giornaliero (rifornire ogni escursione)
    { itemKey: 'zaino-water', label: '1,5–2 L acqua a testa (Vršič, Soča, Logar…)', category: 'zaino' },
    { itemKey: 'zaino-snacks', label: 'Barrette, frutta secca, snack bimbi', category: 'zaino' },
    { itemKey: 'zaino-cash', label: 'Contanti per rifugi (Tamar, baita Logar…)', category: 'zaino' },
    { itemKey: 'zaino-trash', label: 'Sacchetto rifiuti', category: 'zaino' },
    // Settimana 1 — Kranjska Gora: Jasna, Zelenci, Tamar, Fusine, Vršič, Soča, Vintgar, Bled, Vogel, Bohinj, Peričnik
    { itemKey: 's1-early-start', label: 'Sveglia presto — Vintgar (1/7), Vršič (2/7), Vogel (3/7)', category: 'settimana-1' },
    { itemKey: 's1-jasna-swim', label: 'Lago Jasna (28/6): costume + asciugamano per bagno pomeriggio', category: 'settimana-1' },
    { itemKey: 's1-picnic-tamar', label: 'Pranzo al sacco — Val Tamar (29/6) e giornata Vršič/Soča (2/7)', category: 'settimana-1' },
    { itemKey: 's1-fusine-picnic', label: 'Laghi Fusine (30/6): pranzo al sacco, no bagno in lago', category: 'settimana-1' },
    { itemKey: 's1-vintgar-ticket', label: 'Biglietto Vintgar su telefono/Drive (orario fisso, 1/7)', category: 'settimana-1' },
    { itemKey: 's1-bled-walk', label: 'Lago Bled (1/7): scarpe comode per giro ~6 km', category: 'settimana-1' },
    { itemKey: 's1-bohinj-swim', label: 'Lago Bohinj (3/7): costume, asciugamano, ciabatte', category: 'settimana-1' },
    { itemKey: 's1-pericnik-towel', label: 'Peričnik (4/7): asciugamano extra — si passa sotto la cascata', category: 'settimana-1' },
    { itemKey: 's1-afternoon-storms', label: 'Regola montagna: rientro prima del pomeriggio (temporali ARSO)', category: 'settimana-1' },
    // Settimana 2 — Domžale: Lubiana, Velika Planina, Postumia, Snovik, Logar, Piran
    { itemKey: 's2-postumia-fleece', label: 'Postumia + Predjama (8/7): felpe in auto — 8–10 °C in grotta', category: 'settimana-2' },
    { itemKey: 's2-ljubljana-walk', label: 'Lubiana (6/7): scarpe comode, ombrello leggero', category: 'settimana-2' },
    { itemKey: 's2-velika-planina', label: 'Velika Planina (7/7): giacca leggera in quota, pranzo baita o al sacco', category: 'settimana-2' },
    { itemKey: 's2-snovik-slippers', label: 'Terme Snovik (9/7): ciablette piscina + costume', category: 'settimana-2' },
    { itemKey: 's2-logar-picnic', label: 'Valle Logar (10/7): pranzo al sacco + borsa termica (giornata lontana)', category: 'settimana-2' },
    { itemKey: 's2-piran-beach', label: 'Piran (11/7): borsa mare — costume, telo, crema, ciabatte', category: 'settimana-2' },
    { itemKey: 's2-saturday-shopping', label: 'Spesa il sabato — domenica negozi riducono orario', category: 'settimana-2' },
    { itemKey: 's2-laundry-ready', label: 'Lavatrice Domžale: bustine pronte dal 5/7', category: 'settimana-2' },
    // Drone
    { itemKey: 'drone-body', label: 'Drone + batterie cariche + caricatore', category: 'drone' },
    { itemKey: 'drone-label', label: 'Codice operatore UE visibile sul drone', category: 'drone' },
    { itemKey: 'drone-sd', label: 'Scheda SD + cavo (backup video)', category: 'drone' },
    { itemKey: 'drone-zones-ok', label: 'Zone OK (check app): Fusine, Logar, Piran', category: 'drone' },
    { itemKey: 'drone-zones-no', label: 'NO volo Parco Triglav: KG, Zelenci, Vršič, Soča, Bled, Bohinj, Vogel…', category: 'drone' },
    // Il giorno prima
    { itemKey: 'eve-fridge', label: 'Frigo svuotato, spazzatura fuori', category: 'giorno-prima' },
    { itemKey: 'eve-charge', label: 'Carica power bank, telefoni, drone', category: 'giorno-prima' },
    { itemKey: 'eve-cash-cards', label: 'Contanti + carte', category: 'giorno-prima' },
    { itemKey: 'eve-tickets-drive', label: 'Biglietti su Google Drive + screenshot offline', category: 'giorno-prima' },
    { itemKey: 'eve-travel-lunch', label: 'Prepara pranzo al sacco per partenza', category: 'giorno-prima' },
    { itemKey: 'eve-valigie', label: 'Valigie + zaino pronti la sera', category: 'giorno-prima' },
  ],

  /** Luoghi da Google Maps non ancora in itinerario — seed in Da visitare → Da pianificare */
  instanceWishlist: [
    {
      name: 'Brv Brjeka (ponte pedonale Soča)',
      notes: 'Ponte sospeso sul Soča turchese, lungo il sentiero da Bovec. Abbinabile al giorno 4 (Vršič/valle Soča).',
      lat: 46.338139,
      lng: 13.552773,
      mapsUrl: MAPS.brvBrjeka,
      orderIdx: 0,
    },
    {
      name: 'Brv Jablanca (viseča brv)',
      notes: 'Viseča brv da 60 m sul Soča presso Jablanca — collega il giro Bovec–Vodenca–Čezsoča. Giorno 4 o gita da Bovec.',
      lat: 46.33228,
      lng: 13.58853,
      mapsUrl: MAPS.brvJablanca,
      orderIdx: 1,
    },
    {
      name: 'Gola di Pokljuka (Pokljuka Gorge)',
      notes: 'Gola secca con passerelle sopra Bohinj/Bled — opzionale fuori rotta. Abbinabile ai giorni 5–6 (Bled/Bohinj).',
      lat: 46.3766,
      lng: 14.0326,
      mapsUrl: MAPS.pokljukaGorge,
      orderIdx: 2,
    },
    {
      name: 'Fontana della birra (Žalec)',
      notes: 'Green Gold Beer Fountain nel parco di Žalec — degustazione birra a gettone. Giornata lunga da Domžale/Lubiana.',
      lat: 46.2519,
      lng: 15.1648,
      mapsUrl: MAPS.beerFountainZalec,
      orderIdx: 3,
    },
    {
      name: 'Vinska fontana Marezige',
      notes: 'Prima fontana del vino in Slovenia, vista su Istria. Gita costa — abbinabile al giorno 14 (Piran) o mezza giornata.',
      lat: 45.5078,
      lng: 13.7261,
      mapsUrl: MAPS.wineFountainMarezige,
      orderIdx: 4,
    },
    {
      name: 'Restaurant Oštarija (Kranjska Gora)',
      notes: 'Ristorante con terrazza a Kranjska Gora — in lista Dove mangiare. Utile settimana 1.',
      lat: 46.48417,
      lng: 13.78278,
      mapsUrl: MAPS.ostarijaKg,
      orderIdx: 5,
    },
    {
      name: 'Gostilna Vintgar (Podhom)',
      notes: 'Gostilna storica all\'ingresso della gola — pranzo comodo il giorno Vintgar + Bled.',
      lat: 46.39097,
      lng: 14.08389,
      mapsUrl: MAPS.gostilnaVintgar,
      orderIdx: 6,
    },
    {
      name: 'Ladra (borgo sul Soča)',
      notes: 'Piccolo borgo storico sopra Kobarid, sulla sinistra del Soča. Opzionale in zona giorno 4.',
      lat: 46.23858,
      lng: 13.60479,
      mapsUrl: MAPS.ladra,
      orderIdx: 7,
    },
    {
      name: 'Slap Kozjak — viewpoint sentiero',
      notes: 'Ingresso/punto panoramico del sentiero alla cascata Kozjak (grotta-anfiteatro). Tappa opzionale giorno 7.',
      lat: 46.3386,
      lng: 13.6592,
      mapsUrl: MAPS.kozjakViewpoint,
      orderIdx: 8,
    },
    {
      name: 'Repov slap (Luče)',
      notes: 'Cascata nel bosco con ponticelli — tappa extra sulla strada per la Valle di Logar (giorno 13).',
      lat: 46.3542,
      lng: 14.7418,
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Repov+slap+Luče+Slovenia',
      orderIdx: 9,
    },
  ],
};

// Validation: 15 days (2026-06-28 → 2026-07-12), 21 stops total
// Sections: whereToEat, rainPlanB, quickPick (incl. drone + Soča menu + tappe extra), fuel, slovenePhrases (12), ticketsSummary (14)
// Checklist: 73 items (prenotazioni, documenti, auto, app, viaggio, dispensa, valigia, zaino, settimana-1/2, drone, giorno-prima)
// Note: mapsUrl built from place names (PDF QR codes are raster images, not extractable as URLs)
